import { useIntl } from "react-intl";
import { DetailsField } from "components/DetailsField";
import { ActivityDetailsCouponProps } from "./types";
import { messages } from "./messages";
import { useFormatter } from "hooks/utils/useFormatter";
import dayjs from "dayjs";
import { ActivityDetailField } from "../ActivityDetailField";
import { DownloadActivityEscoCoupon } from "./components/DownloadActivityEscoCoupon";

export const ActivityDetailsCoupon: React.FC<ActivityDetailsCouponProps> = ({
  data,
}) => {
  const { formatMessage } = useIntl();
  const { formatValue } = useFormatter();

  const receipt = data.data;

  return (
    <div className="flex flex-col gap-y-6 pdf:p-10">
      <h2 className="text-2xl font-bold text-[--milkylb-color-neutral-400]">
        {receipt.operation_type}
      </h2>
      <ActivityDetailField
        separator
        label={formatMessage(messages.agreementLabel)}
        value={dayjs(receipt.agreement_date).format("DD.MM.YYYY HH:mm")}
      />
      <ActivityDetailField
        separator
        label={formatMessage(messages.liquidationLabel)}
        value={dayjs(receipt.settlement_date).format("DD.MM.YYYY HH:mm")}
      />
      <DetailsField
        className="mb-2 mt-2"
        label={formatMessage(messages.descritionLabel)}
        value={receipt.instrument}
      />
      <ActivityDetailField
        separator
        label={formatMessage(messages.quantityLabel)}
        value={formatValue(receipt.quantity.toString())}
      />
      <ActivityDetailField
        separator
        label={formatMessage(messages.priceLabel)}
        value={formatValue(receipt.price.toString())}
      />
      <ActivityDetailField
        separator
        label={formatMessage(messages.valuationLabel)}
        value={formatValue(receipt.net.toString())}
      />
      <ActivityDetailField
        separator
        label={formatMessage(messages.grossLabel)}
        value={formatValue(receipt.gross.toString())}
      />
      <ActivityDetailField
        separator
        label={formatMessage(messages.taxLabel)}
        value={formatValue(receipt.market_right.toString())}
      />
      <DownloadActivityEscoCoupon couponId={data.id} />
    </div>
  );
};
